import { useState } from "react";
import { api, errMsg, money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { toast } from "sonner";

function refundText(q) {
  if (q.percent === 100) return `You'll get a full refund of ${money(q.refund)}.`;
  if (q.percent === 50) return `You're ${q.days_before} days from check-in, so you'll get a 50% refund of ${money(q.refund)}.`;
  return `You're ${q.days_before} days from check-in, so this stay can't be refunded.`;
}

// Guest cancels a paid stay; the refund follows the cancellation policy and goes back to their card.
export function CancelStayDialog({ booking, onDone }) {
  const [quote, setQuote] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    try {
      const { data } = await api.get(`/bookings/${booking.booking_id}/cancel-quote`);
      setQuote(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/bookings/${booking.booking_id}/cancel`);
      toast.success(data.refund > 0 ? `Stay cancelled. ${money(data.refund)} is on its way back to your card.` : "Stay cancelled.");
      setQuote(null);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Button size="sm" variant="ghost" className="rounded-full" data-testid={`trip-cancel-stay-${booking.booking_id}`} onClick={open}>Cancel stay</Button>
      <AlertDialog open={!!quote} onOpenChange={(o) => !o && setQuote(null)}>
        <AlertDialogContent data-testid="cancel-stay-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Cancel this stay?</AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-2">
                <p className="font-semibold text-stone-900" data-testid="cancel-stay-refund">{quote && refundText(quote)}</p>
                <p data-testid="cancel-stay-policy">{quote?.policy_name} policy: {quote?.policy} Refunds usually reach your card in 5–10 business days.</p>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="cancel-stay-keep">Keep my stay</AlertDialogCancel>
            <AlertDialogAction data-testid="cancel-stay-confirm" disabled={busy} onClick={(e) => { e.preventDefault(); confirm(); }} className="bg-red-600 hover:bg-red-700">
              {busy ? "Cancelling…" : "Cancel stay"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
